<template>
  <div class="sidebar-detached sidebar-left">
    <div class="sidebar">
      <div
        class="sidebar-shop"
        :class="{'show': mqShallShowLeftSidebar}"
      >
        <h6 class="filter-heading d-none d-lg-block">
          Filtros
        </h6>

        <!-- Filters' Card -->
        <b-overlay
          :show="loader.filters"
          opacity="0.50"
          rounded="sm"
        >
          <b-card
            :class="{'this-is-smallScreen': mqShallShowLeftSidebar}"
          >
            <!-- Especialidades -->
            <div class="product-categories">
              <h6 class="filter-title mt-0">
                Especialidades
              </h6>
              <b-form-radio-group
                v-model="filters.especialidad"
                class="brands-radio-group"
                stacked
                :options="especialidades"
                value-field="plan_id"
                text-field="nombre"
              />
            </div>

            <!-- Temporalidad -->
            <transition name="fade">
              <div
                v-if="shop.temporalidad && shop.temporalidad.length"
                class="brands"
              >
                <h6 class="filter-title">
                  Temporalidad
                </h6>
                <b-form-radio-group
                  v-model="filters.temporalidad"
                  class="brands-radio-group"
                  stacked
                  :options="shop.temporalidad"
                  value-field="orden"
                  text-field="nombreCompleto"
                />
              </div>
            </transition>

            <!-- Borrar filtros -->
            <transition name="fade">
              <b-card-footer
                v-if="filters.temporalidad > 0 || filters.search != ''"
                class="text-center mt-3 pb-0"
              >
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-danger"
                  class="btn-icon mr-75"
                  @click="$emit('borrarFiltros')"
                >
                  <feather-icon
                    icon="XIcon"
                  />
                  Eliminar filtros
                </b-button>
              </b-card-footer>
            </transition>
          </b-card>
        </b-overlay>
      </div>
    </div>

    <div
      class="body-content-overlay"
      :class="{'show': mqShallShowLeftSidebar}"
      @click="$emit('update:mq-shall-show-left-sidebar', false)"
    />
  </div>
</template>

<script>
import {
  BCard,
  BCardFooter,
  BFormRadioGroup,
  BOverlay,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  ref, onMounted, computed,
} from '@vue/composition-api'
import store from '@/store/index'

export default {
  components: {
    BCard,
    BCardFooter,
    BFormRadioGroup,
    BOverlay,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const especialidades = ref([])
    const loader = ref({ filters: false })
    const shop = computed(() => store.state.eCommerce.shop)

    const fetchEspecialidades = () => {
      loader.value.filters = true // Start general loader - change ref value (loader.general)
      store.dispatch('cuenta/get_especialidades')
        .then(response => {
          loader.value.filters = false // Stop general loader - change ref value (loader.general)
          especialidades.value = response
          // eslint-disable-next-line no-param-reassign
          props.filters.especialidad = response[0].plan_id
          emit('loadShopItems')
        }, () => {
          loader.value.filters = false // Stop general loader - change ref value (loader.general)
        })
    }

    // On mounted fetch user's data
    onMounted(() => { fetchEspecialidades() })

    return {
      shop,
      especialidades,
      loader,
    }
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-slider.scss';
</style>

<style lang="scss" scoped>
.categories-radio-group,
.brands-radio-group,
.price-range-defined-radio-group {
    ::v-deep > .custom-control {
    margin-bottom: 0.75rem;
  }
}

.this-is-smallScreen {
  padding-top: 5rem;
  height: 100vh !important;
}
</style>
